import { inject, injectable } from "../injection";
import { makeObservable, observable, runInAction } from "mobx";
import { MessageBusService } from "../messageBus/MessageBusService";

@injectable("singleton")
export class LegacyTimelineDataStore {
    @observable public isReady = false;
    @observable.shallow
    public response?: RedDeer.Contracts.Queries.Timeline.GetTimelineDataResponse;

    constructor(
        @inject(MessageBusService) private messageBusService: MessageBusService
    ) {
        makeObservable(this);

        void this.getData();
    }

    private async getData() {
        // otherwise, get from message bus
        const query: RedDeer.Contracts.Queries.Timeline.GetTimelineDataQuery = {
            MessageType: "Queries.Timeline.GetTimelineDataQuery"
        };

        const response =
            await this.messageBusService.sendPromise<RedDeer.Contracts.Queries.Timeline.GetTimelineDataResponse>(
                {
                    request: query,
                    description: "loading core application data"
                }
            );

        runInAction(() => {
            this.isReady = true;
            this.response = response;
        });
    }
}
